import React from 'react';
import { DatePicker } from 'antd';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import Status from './../../../../TopQualities/status.jsx';
import style from './style.module.scss';

const DateFieldInput = ({ name, label, placeholder, isRequired = false, ...restProps }) => {
  return (
    <Field name={name}>
      {({ field, form }) => {
        const value = form.values[name];
        const touched = form.touched[name];
        const error = form.errors[name];
        const showError = touched && (!value || error);

        return (
          <div className={style['input-wrapper']}>
            {label && (
              <p className={style.label}>
                <span>{label}</span>
                {isRequired && <Status isFilled={!showError && !!value} />}
              </p>
            )}

            <div className={style.box}>
              <DatePicker
                id={name}
                className={style.input}
                placeholder={placeholder}
                status={showError ? 'error' : ''}
                value={value}
                onChange={(val) => form.setFieldValue(name, val)}
                onBlur={() => form.setFieldTouched(name, true)}
                style={{ width: '100%' }}
                {...restProps}
              />
            </div>

            {showError && <p className={style.error}>{error || `${label} is required`}</p>}
          </div>
        );
      }}
    </Field>
  );
};

DateFieldInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
};

export default DateFieldInput;
